<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style type="scss">
  @font-face {
    font-family: Rubik;
    src: url(/static/fonts/Rubik-Regular.ttf) format("truetype");
  }

  html,
  body {
    margin: 0;
    padding: 0;
  }

  .v-application {
    font-family: "Rubik", sans-serif !important;
  }

  .title-bold {
    font-weight: bold;
  }

  .cxlt-toastr-container {
    font-family: "Rubik", sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue